import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { ApiService } from '../../../../services/api/api.service';
import { NbToastrService } from '@nebular/theme';

@Component({
  selector: 'create-req-copy',
  templateUrl: './create-req-copy.component.html',
  styleUrls: ['./create-req-copy.component.css']
})
export class CreateReqCopyComponent implements OnInit {

//context.confirmationService.confirm({
//          message: 'Are you sure you would like to make a copy of this requisition?',
//          header: 'Copy requisition',
//          icon: 'pi pi-exclamation-triangle',
//          accept: () => {
//            context.loading = true;
//            context.apiService.post(`/api/requisition/createCopy/${context.entityId}`)
//              .subscribe(o => {
//                context.loading = false;
//                context.messageService.success('Copied successfully', 'Action');
//                context.parent.navigateToIndex(1, o, 1);
//              }, err => {
//                context.loading = false;
//                context.messageService.danger('Could not save. ' + err.error, 'Action');
//              })
//          },
//          reject: () => {
//
//          }
//        })

  private requisitionId: any;
  private requisitionPartialId: any;
public context:any;
  public loading: boolean;
  public items: any;
  public addGlobalEmail: boolean;
  public globalEmail: any;
  public logs: any = new Array();
public defaultDate:any;
  constructor(public config: DynamicDialogConfig, public ref: DynamicDialogRef,
    private apiService: ApiService,
    private messageService?: NbToastrService) {
this.defaultDate = new Date();
    if (config && config.data && config.data.requisitionId) {
      this.requisitionId = config.data.requisitionId;
    }
this.context = config.data.context;



  }

  ngOnInit() {
  }

  

  public save() {
          this.loading = true;
            this.apiService.post(`/api/requisition/createCopy/${this.requisitionId}`, {defaultDueDate: this.defaultDate})
              .subscribe(o => {
                this.loading = false;
                this.messageService.success('Copied successfully', 'Action');
    this.ref.close(o);
              }, err => {
                this.loading = false;
                this.messageService.danger('Could not save. ' + err.error, 'Action');
              })
  }

  public cancel() {
    this.ref.close();
  }
}
